import type { Org } from '../helpers/device.helper';
import type { LabelTKey } from '../i18n';

export type Advocate = {
  advocate_id: string;
  available: boolean;
  name: string;
  img_url: string | null;
  in_chat: boolean;
  org_name: string;
  org_code: Org;

  /** Only for LEPS */
  spoken_languages?: string[];
  /** Only for LEPS */
  community_names?: string[];
  /** Only for LEPS */
  lived_experiences?: LabelTKey[];
  /** Only for SP */
  service_provider_organization_id?: string | null;
  /** Only for SP */
  service_provider_organization_name?: string | null;
  /** Only for SP */
  service_provider_organization_internal?: boolean | null;
  /** Only for SP */
  service_provider_title?: string | null;
  /** Only for SP */
  service_title?: string | null;
  /** Only for SP */
  service_description?: string | null;
};

export class Profile {
  first_name: string | null = null;
  last_name: string | null = null;
  nickname: string | null = null;
  email = '';
  label_ids: string[] = [];
  labels: string[] = [];
  id = '';
  img_url = '';
  // Service provider
  service_provider_organization_id?: string;
  service_provider_title?: string | null = null;
  service_title?: string | null = null;
  service_description?: string | null = null;
  service_provider_organization_name?: string | null = null;
}

export type Label = {
  alias: LabelTKey;
  id: string;
  name: string;
  order: number | null;
  indigenous_name?: string | null;
};

export type LabelGroup = {
  tab_alias: string | null;
  group_alias: LabelTKey;
  group_order: number;
  required: boolean | null;
  labels: Label[];
  single_select: boolean;
};

export class AdvocatePostChatSurvey {
  thread_id: string | null = null;
  end_reason_id: string | null = null;
  comments: string | null = null;
  referred_guest: boolean | null = null;
  subject_ids: string[] = [];
  other_subject: string | null = null;
  is_training = false;
  abuse_rating: number | null = null;
}

export type SessionLog = {
  month: number | undefined;
  year: number | undefined;
};

export type SessionLogResponse = {
  advocate_post_chat_survey_complete: boolean;
  chat_id: string;
  email: string;
  end_timestamp: string;
  first_name: string;
  last_name: string;
  org_name: string;
  org_timezone_name: string;
  start_timestamp: string;
  trigger_timestamp: string;
  thread_id: string;
  time_expired: boolean;
};

export type AdvocateHoursResponse = {
  time_online: string;
};
